module.exports = __webpack_public_path__ + "static/media/hjqxyl.b2aba613.png";